import React, {FunctionComponent} from 'react';
import {Button, ButtonProps, Stack, SxProps, Theme} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

export type FormActionsProps = {
    onCancel?: () => void;
    onSave?: () => void;
    saveDisabled?: boolean;
    saveText?: string;
    cancelText?: string;
    sx?: SxProps<Theme>;
    saveButtonProps?: ButtonProps;
    cancelButtonProps?: ButtonProps;
};

const FormActions: FunctionComponent<FormActionsProps> = ({
                                                               onCancel,
                                                               onSave,
                                                               saveDisabled = false,
                                                               saveText = "Speichern",
                                                               cancelText = "Abbrechen",
                                                               sx,
                                                               saveButtonProps,
                                                               cancelButtonProps,
                                                           }) => {
    return (
        <Stack direction="row" justifyContent="flex-end" gap={1} sx={sx}>
            {onCancel && (
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onCancel}
                    {...cancelButtonProps}
                >
                    {cancelText}
                </Button>
            )}
            {onSave && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onSave}
                    disabled={saveDisabled}
                    startIcon={<SaveIcon/>}
                    {...saveButtonProps}
                >
                    {saveText}
                </Button>
            )}
        </Stack>
    );
};

export default FormActions;
